import SignUp from '@/components/views/sign-up/SignUp'
import Settings from '@/components/views/auth/Settings'
import Login from '@/components/views/auth/Login'
import ForgotPassword from '@/components/views/auth/ForgotPassword'

const app = process.env.APP_NAME
export default [
  {
    path: '/sign-up/:step',
    name: 'SignUp',
    component: SignUp,
    meta: {auth: false, title: `${app}: Sign Up`, pageTitle: 'Sign Up', layout: 'standard'}
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {auth: false, title: `${app}: Login`, layout: 'standard'}
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {auth: false, title: `${app}: Forgot password`, pageTitle: 'Forgot password', layout: 'standard'}
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {auth: true, title: `${app}: My settings`, pageTitle: 'My Settings', layout: 'standard'}
  }
]



// WEBPACK FOOTER //
// ./src/router/auth-routes.js